import { EncryptedField } from "core/types";

export function getEncryptedFieldDefault(decrypted: string | undefined | null) {
  return decrypted ? { decrypted } : null;
}
export function getEncryptedField(
  field: EncryptedField | string | null | undefined,
) {
  if (typeof field === "string") return field;
  return field?.decrypted;
}

export function getDecryptedValue(v: EncryptedField | null | undefined) {
  if (!v) return null;
  return v.decrypted;
}

export function toEncryptedField(value: string): EncryptedField {
  return {
    content: "",
    decrypted: value,
    iv: "",
    seald_content: "",
  };
}
